module.exports = __webpack_public_path__ + "static/media/10-normal.96bd4083.png";